import axiosClient from '../axiosClient';
import { WarehouseEndpoints } from '../endpoints/warehouse';
import { WarehouseResponse } from '../../types/api/response/warehouseresponse';
import {
  CreateWarehouseRequest,
  UpdateWarehouseRequest,
} from '../../types/api/request/warehouserequest';

export const WarehouseService = {
  async listWarehouses(activeOnly?: boolean): Promise<WarehouseResponse[]> {
    const res = await axiosClient.get<WarehouseResponse[]>(WarehouseEndpoints.LIST, {
      params: { active_only: activeOnly ?? false },
    });
    return res.data;
  },

  async getWarehouse(id: number): Promise<WarehouseResponse> {
    const url = WarehouseEndpoints.GET.replace(':id', id.toString());
    const res = await axiosClient.get<WarehouseResponse>(url);
    return res.data;
  },

  async createWarehouse(body: CreateWarehouseRequest): Promise<WarehouseResponse> {
    const res = await axiosClient.post<WarehouseResponse>(WarehouseEndpoints.CREATE, body);
    return res.data;
  },

  async updateWarehouse(id: number, body: UpdateWarehouseRequest): Promise<WarehouseResponse> {
    const url = WarehouseEndpoints.UPDATE.replace(':id', id.toString());
    const res = await axiosClient.put<WarehouseResponse>(url, body);
    return res.data;
  },
};
